import {array, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringOptionalNullable} from '@shared/utils';
import {REFERRAL_PAYMENT_STATUSES, REFERRAL_TARGET_ACTIONS} from '../types';

export const referralRecordV8nSchema = object().shape({
  master_account_id: string().required(),
  referral_account_id: string().required(),
  registered_at: string().required(),
  first_real_order_at: stringOptionalNullable,
  target_action: string().oneOf(REFERRAL_TARGET_ACTIONS).required(),
  payment_amount: number().required(),
  payment_status: string().oneOf(REFERRAL_PAYMENT_STATUSES).required(),
  referral_pnl: number().required(),
});

export const v8nSchemaOfGetReferralsResponse = paginationV8nSchema.shape({
  array: array().of(referralRecordV8nSchema).required(),
});
